module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp12_7.44a060a1.png";